// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-11a1de43]{border-bottom:2px solid #bdbdbd}.footer[data-v-11a1de43]{border-top:1px solid #bdbdbd}", ""]);
// Exports
module.exports = exports;
